import { Component, input, computed, model } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PaginationComponent {
  // Signal-based inputs
  collectionSize = input<number>(0);
  maxSize = input<number>(5);
  itemsPerPage = input<number>(10);

  // Two-way binding for page (`[(page)]` / `(pageChange)` come from model())
  page = model<number>(1);

  // Computed total pages
  totalPages = computed(() => {
    const size = this.collectionSize();
    const perPage = this.itemsPerPage();
    if (!size || !perPage) return 0;
    return Math.ceil(size / perPage);
  });

  // Computed page numbers to display
  pages = computed(() => {
    const pages: number[] = [];
    const total = this.totalPages();
    const current = this.page();
    const max = this.maxSize();

    if (total <= 0) return pages;

    const startPage = Math.max(1, current - Math.floor(max / 2));
    const endPage = Math.min(total, startPage + max - 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  });

  goToPage(pageNumber: number): void {
    const current = this.page();
    const total = this.totalPages();

    if (pageNumber >= 1 && pageNumber <= total && pageNumber !== current) {
      // model() emits pageChange automatically — do not declare a separate output
      this.page.set(pageNumber);
    }
  }

  previousPage(): void {
    this.goToPage(this.page() - 1);
  }

  nextPage(): void {
    this.goToPage(this.page() + 1);
  }
}
